import React, { useEffect, useState } from "react";
import api from "~/services/api";
import { LandPage, Container, Main } from './styles';
import { useSelector } from "react-redux";
import TableComponent from "./TableComponent";

export default function HistoricoEnvio() {
  const [data, setData] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [mountedData, setMountedData] = useState();
  const [loadedData, setLoadedData] = useState(false);
  const { perfil, idUnidades, controle } = useSelector(state => state.auth);
  const [unidades, setUnidades] = useState([]);

  useEffect(() => {
    setLoadedData(false);
  }, [perfil]);

  useEffect(() => {
    async function handleRequests() {
      api
        .get('/signed/geral/acessos/check')
        .then(response => setModulos(response.data));
    }

    handleRequests();
        
    api.get('/signed/cliente/administracao/organizacao/unidades', { params: { centroCusto: "S" } }).then(response => {
      let lista = [];
      for (const item of idUnidades) {
        const itemFind = response?.data?.find((o) => o?.id == item);
        
        if (itemFind) {
          let listaCC = [];
          for (const itemCC of itemFind?.centroCustos) {
            listaCC.push({ id: itemCC?.id, titulo: itemCC?.titulo });
          }

          lista.push({ id: itemFind?.id, titulo: itemFind?.nome, centroCustos: listaCC });
        }
      }
      setUnidades(lista);
    });
  }, []);

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Container
            requests={{
              findAll: () =>
                api.get('/signed/cliente/pesquisa/email/historicoenvio'),
            }}
            setter={setData}
            setLoaded={setLoadedData}
            loaded={loadedData}
            informationPage={{
              title: 'Historico de Envio dos Emails',
              subTitle: "Visualize o histórico de envio dos emails",
              icone: 'submenu-centrocusto',
            }}
            pageSize={7}
            inputs={[
              { filter: 'id', label: 'id' },
            ]}
            selects={[
              {
                list: unidades,
                value: "id",
                label: "titulo",
                outLabel: "Todas Unidades",
                filter: "idUnidade",
              },
            ]}
          >
            <TableComponent />
          </Container>
        </div>
      </LandPage>
    </Main>
  );
}
